export default __webpack_public_path__ + "assets/images/657d26a73360689e6faf2c86ef53bbf1.png";